import './style.css';

const Conquistas = ({ Conquista, getnome }) => {
  return (
    <div className='welcome-card-container mb-4'>      
      <div className='welcome-card' onClick={Conquista}>
        <div className='welcome-content'>
          <h1 className='welcome-title'>Olá, {getnome}!</h1>
          <p className='welcome-subtitle'>Veja suas conquistas e benefícios hoje.</p>
        </div>
        <div className='welcome-icon'>
          <i className="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  );
};

export default Conquistas;
